import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrderService } from './order.service';
import { map, of } from 'rxjs';

export const orderStatusGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const orderService = inject(OrderService);
  const orderId = route.parent?.paramMap.get('id');
  const requestedStep = route.url[0]?.path; // e.g., 'dispatch'

  const statusToRoute: Record<string, string> = {
    'to_be_authorize': 'authorize',
    'in_progress': 'preparation',
    'on_hold': 'hold',
    'hold': 'hold',
    'cancel': 'cancel',
    'canceled': 'cancel',
    'cancelled': 'cancel',
    'order_canceled': 'cancel',
    'order_cancelled': 'cancel',
    'rejected': 'reject',
    'order_rejected': 'reject',
    'order_ready': 'dispatch',
    'in_delivery': 'delivery',
    'delivery_complete': 'payments',
    'completed': 'payments',
    
  };

  // If we already have the status in the signal, use it; otherwise, return true to let parent load it
  const currentStatus = (orderService.activeOrderStatus() || '').toLowerCase();
  if (!currentStatus) return true;

  const allowedRoute = statusToRoute[currentStatus];

  if (requestedStep === allowedRoute) {
    return true;
  } else {
    // Redirect to the only allowed page
    router.navigate(['/orders/process', orderId, allowedRoute]);
    return false;
  }
};
